export const cinematicModalBackdropClass =
  "fixed inset-0 z-[10000] bg-black/75 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0";

export const cinematicModalPanelClass =
  "fixed left-4 right-4 top-1/2 z-[10001] flex max-h-[calc(100dvh-2rem)] -translate-y-1/2 flex-col overflow-hidden rounded-lg border border-white/10 bg-[#121318] shadow-[0_28px_90px_rgba(0,0,0,0.55)] outline-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:left-1/2 sm:right-auto sm:w-full sm:-translate-x-1/2";

export const cinematicModalCloseButtonClass =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-white/10 text-white/55 transition-colors hover:bg-white/[0.06] hover:text-white";

export const cinematicModalTitleClass = "text-lg font-bold text-white sm:text-xl";

export const cinematicModalSubtitleClass = "mt-1 text-sm text-white/55";

export const cinematicModalLabelClass = "mb-1.5 block text-xs font-semibold text-white/55";

export const cinematicModalInputClass =
  "block w-full rounded-lg border border-white/10 bg-white/[0.04] px-4 py-2.5 text-sm font-semibold text-white placeholder:text-white/35 outline-none transition-colors hover:bg-white/[0.06] focus:border-orange-300/55";

export const cinematicModalTextareaClass =
  "block w-full resize-y rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3 text-sm font-medium leading-relaxed text-white placeholder:text-white/35 outline-none transition-colors hover:bg-white/[0.06] focus:border-orange-300/55";

export const cinematicModalSecondaryButtonClass =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/[0.04] px-4 text-sm font-semibold text-white transition-colors hover:border-orange-300/35 hover:bg-white/[0.07] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300/60 disabled:cursor-not-allowed disabled:opacity-60";

export const cinematicModalPrimaryButtonClass =
  "inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-[#FD954F]/70 bg-[#FD954F] px-4 text-sm font-bold text-[#1C1C1E] transition-colors hover:bg-[#F28747] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300/60 disabled:cursor-not-allowed disabled:opacity-70";

export const cinematicModalSectionClass = "rounded-lg border border-white/10 bg-white/[0.025] p-4";

export const cinematicModalSelectClass =
  "w-full rounded-lg border border-white/10 bg-white/[0.04] px-4 py-2.5 text-sm font-semibold text-white outline-none transition-colors focus:border-orange-300/55";

export const cinematicModalMaxWidthClass = {
  md: "max-w-md",
  lg: "max-w-lg",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "6xl": "max-w-6xl",
} as const;
